export function Coin({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.9219 16.7496C21.5919 19.4096 19.4119 21.5896 16.7519 21.9196C15.1419 22.1196 13.6419 21.6796 12.4719 20.8196C11.8019 20.3296 11.9619 19.2896 12.7619 19.0496C15.7719 18.1396 18.1419 15.7596 19.0619 12.7496C19.3019 11.9596 20.3419 11.7996 20.8319 12.4596C21.6819 13.6396 22.1219 15.1396 21.9219 16.7496Z"
          fill="currentColor"
        />
        <path
          d="M9.99195 2C5.58195 2 2.00195 5.58 2.00195 9.99C2.00195 14.4 5.58195 17.98 9.99195 17.98C14.402 17.98 17.982 14.4 17.982 9.99C17.972 5.58 14.402 2 9.99195 2ZM9.05195 8.87L11.462 9.71C12.332 10.02 12.752 10.63 12.752 11.57C12.752 12.65 11.892 13.54 10.842 13.54H10.752V13.59C10.752 14 10.412 14.34 10.002 14.34C9.59195 14.34 9.25195 14 9.25195 13.59V13.53C8.14195 13.48 7.25195 12.55 7.25195 11.39C7.25195 10.98 7.59195 10.64 8.00195 10.64C8.41195 10.64 8.75195 10.98 8.75195 11.39C8.75195 11.75 9.01195 12.04 9.33195 12.04H10.832C11.062 12.04 11.242 11.83 11.242 11.57C11.242 11.22 11.182 11.2 10.952 11.12L8.54195 10.28C7.68195 9.98 7.25195 9.37 7.25195 8.42C7.25195 7.34 8.11195 6.45 9.16195 6.45H9.25195V6.41C9.25195 6 9.59195 5.66 10.002 5.66C10.412 5.66 10.752 6 10.752 6.41V6.47C11.862 6.52 12.752 7.45 12.752 8.61C12.752 9.02 12.412 9.36 12.002 9.36C11.592 9.36 11.252 9.02 11.252 8.61C11.252 8.25 10.992 7.96 10.672 7.96H9.17195C8.94195 7.96 8.76195 8.17 8.76195 8.43C8.75195 8.77 8.81195 8.79 9.05195 8.87Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
